import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBFgIrElzc2xvKhrQzUICELfV_nyk5QDc8",
  authDomain: "lifetime-timer-prod.firebaseapp.com",
  projectId: "lifetime-timer-prod",
  storageBucket: "lifetime-timer-prod.firebasestorage.app",
  messagingSenderId: "174789461876",
  appId: "1:174789461876:web:c8e2448a1383db20cf4e21",
  measurementId: "G-W9L9VNM7PH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and export it
const analytics = getAnalytics(app);

export { app, analytics }; 